import { render, staticRenderFns } from "./entry-university.vue?vue&type=template&id=13dc9ba0&"
import script from "./entry-university.vue?vue&type=script&lang=js&"
export * from "./entry-university.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports